import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import {
  availableToBgColor,
  availableToColor,
  availableToTranslationKey,
  isRackType,
  normalizeRackAvailableLevel
} from '../../helpers'

export const getResolvedEquipmentStatus = (equipment, t) => {
  if (!equipment) {
    return {
      label: t(availableToTranslationKey('unknown')),
      color: availableToColor('unknown'),
      bgcolor: availableToBgColor('unknown'),
      level: 'unknown'
    }
  }

  const rawLevel = ['hibernation', 'works'].includes(equipment.available_level)
    ? `${equipment.available_level}_${equipment.is_reachable ? 'up' : 'down'}`
    : equipment.available_level
  const level = isRackType(equipment?.type) ? normalizeRackAvailableLevel(rawLevel) : rawLevel

  return {
    label: equipment.manufacturer?.toLowerCase() === 'juniper' ? '-' : t(availableToTranslationKey(level)),
    color: availableToColor(level),
    bgcolor: availableToBgColor(level),
    level
  }
}

const EquipmentStatusChip = ({ equipment, status, compact = false }) => {
  const { t } = useTranslation()
  const resolvedStatus = status || getResolvedEquipmentStatus(equipment, t)

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      gap={0.5}
      sx={{
        minWidth: compact ? 'auto' : 96,
        width: 'max-content',
        height: 24,
        px: compact ? '6px' : '8px',
        borderRadius: '999px',
        backgroundColor: resolvedStatus.bgcolor,
        color: resolvedStatus.color,
        flexShrink: 0
      }}
    >
      <Box
        component="span"
        sx={{
          width: 5,
          height: 5,
          borderRadius: '50%',
          backgroundColor: resolvedStatus.color,
          opacity: 0.9,
          flexShrink: 0
        }}
      />
      <Typography component="span" sx={{ fontSize: 10, lineHeight: '12px', fontWeight: 400, color: resolvedStatus.color, whiteSpace: 'nowrap' }}>
        {resolvedStatus.label}
      </Typography>
    </Stack>
  )
}

export default EquipmentStatusChip
